enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}

enum ResolvedThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export { ThemeMode, ResolvedThemeMode };
